import React from "react";
import { Route, Routes } from "react-router-dom";
import { Contact } from "./FrontEnd/Contacts/Contact";
import { ContactList } from "./FrontEnd/Contacts/ContactList";
import { Lead } from "./FrontEnd/Masters/Lead/Lead";
import { LeadList } from "./FrontEnd/Masters/Lead/LeadList";
import ParentComponent from "./FrontEnd/testdynamic";

import { CreateDeals } from "./FrontEnd/Common/Deals/Create/CreateDeals";
import { CreateMeeting } from "./FrontEnd/Common/Deals/Create/CreateMeeting";
import { CreateTask } from "./FrontEnd/Common/Deals/Create/CreateTask";
import { DealList } from "./FrontEnd/Common/Deals/DealList";
import { TaskList } from "./FrontEnd/Common/TaskList";
import { ContactDeatails } from "./FrontEnd/Contacts/ContactDetails/ContactDeatails";
import { Estimation } from "./FrontEnd/Estimation/Estimation";
import { EstimationList } from "./FrontEnd/Estimation/EstimationList";
import { LeadDetails } from "./FrontEnd/Masters/LeadDetails/LeadDeatails";
import { Orders } from "./FrontEnd/Orders/Orders";
import { Quote } from "./FrontEnd/Quatation/Quatation";
import { QuoteList } from "./FrontEnd/Quatation/QuatationList";
import { UserManagement } from "./FrontEnd/Users/UserRegistration";

import { CallLogList } from "./FrontEnd/Common/CallLogList";
import { CreateCallLog } from "./FrontEnd/Common/Deals/Create/CreateCallLog";
import { CreateNotes } from "./FrontEnd/Common/Deals/Create/CreateNotes";
import { NotesList } from "./FrontEnd/Common/NotesList";
import { UserList } from "./FrontEnd/Users/UserList";
import { CreateRole } from "./FrontEnd/Roles/CreateRole";
import { RoleList } from "./FrontEnd/Roles/RoleList";
import { MeetingList } from "./FrontEnd/Common/Deals/MeetingList";
import QPrint from "./FrontEnd/Quatation/Print";
import EPrint from "./FrontEnd/Estimation/Print";
import { ViewSurveyorTaskDetails } from "./FrontEnd/Contacts/ContactDetails/ViewSurveyorTaskDetails";
import DashboardOverview from "./FrontEnd/Dashboard/Dashboard";
import Product from "./FrontEnd/Masters/Product/Product";
import { ProductList } from "./FrontEnd/Masters/Product/ProductList";
import EMartinPrint from "./FrontEnd/Estimation/PrintMartin";
import QMartinPrint from "./FrontEnd/Quatation/PrintMartin";
import { BranchList } from "./FrontEnd/Masters/Branch/BranchList";
import { Branch } from "./FrontEnd/Masters/Branch/Branch";
import PrintDocBuilder from "./FrontEnd/PrintTemplate/PrintDocBuilder";
import { Invoice } from "./FrontEnd/Invoice/Invoice";
import { VendorList } from "./FrontEnd/Vendor/VendorList";
import {CreateVendor} from "./FrontEnd/Vendor/CreateVendor";
import  {PurchaseOrderList}  from "./FrontEnd/PurchaseOrder/PurchaseOrderList";
import {CreatePurchaseOrder} from "./FrontEnd/PurchaseOrder/CreatePurchaseOrder";
import { CreateVendorBill } from "./FrontEnd/VendorBill/CreateVendorBill";
import  {VendorBillList}  from "./FrontEnd/VendorBill/VendorBillList";
import { CreateVendorPayment } from "./FrontEnd/VendorPayment/CreateVendorPayment";
import { VendorPaymentList } from "./FrontEnd/VendorPayment/VendorPaymentList";
import { CreateExpense } from "./FrontEnd/Expense/CreateExpense";
import { ExpenseList } from "./FrontEnd/Expense/ExpenseList";







interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  // if (!token) {
  //   return token ? <Outlet /> : <Navigate to="/login" />;
  // }

  return (
    <Routes>
      {/* <Route path="/" element={<Layout />}/> */}
      <Route path="/leads/list" element={<LeadList />} />
      <Route path="/home" element={<DashboardOverview />} />
      <Route path="/leads/create" element={<Lead />} />
      {/* <Route path="/leads/edit/:id" element={<LeadEdit/>}/> */}
      <Route path="/leads/edit/:id" element={<LeadDetails />} />

      <Route path="/contacts/list" element={<ContactList />} />
      <Route path="/contact/create" element={<Contact />} />
      <Route path="/contact/edit/:id" element={<ContactDeatails />} />

      <Route path="/deals/list" element={<DealList />} />
      <Route path="/deal/create" element={<CreateDeals />} />
      <Route path="/deal/edit/:id" element={<CreateDeals />} />

      {/* Quotations */}
      <Route path="/quatation/list" element={<QuoteList />} />
      <Route path="/quatation/:id?" element={<Quote />} />
      {/* <Route path="/quatation/print/:id?" element={<QPrint />} /> */}



      <Route path="/user/list" element={<UserList />} />
      <Route path="/user/registration" element={<UserManagement />} />
      <Route path="/user/registration/edit/:id" element={<UserManagement />} />


      <Route path="/test" element={<ParentComponent />} />

      <Route path="/meeting/list" element={<MeetingList />} />
      <Route path="/meeting/create" element={<CreateMeeting />} />
      <Route path="/meeting/edit/:id" element={<CreateMeeting />} />

      <Route path="/task/list" element={<TaskList />} />
      <Route path="/task/create" element={<CreateTask />} />
      <Route path="/task/edit/:id" element={<CreateTask />} />


      <Route path="/note/list" element={<NotesList />} />
      <Route path="/note/create" element={<CreateNotes />} />
      <Route path="/note/edit/:id" element={<CreateNotes />} />

      <Route path="/call/list" element={<CallLogList />} />
      <Route path="/call/create" element={< CreateCallLog />} />
      <Route path="/call/edit/:id" element={<CreateCallLog />} />
      {/* Estimation */}
      <Route path="/estimation/list" element={<EstimationList />} />
      <Route path="/contact/edit/:id/estimation/:estId?" element={<Estimation />} />
      <Route path="/contact/edit/:id/quatation/:quId?" element={<Quote />} />
      <Route path="/contact/edit/:id/order/:orderId?" element={<Orders />} />
      <Route path="/contact/edit/:id/quatation/convert-quatation/:estimatId?" element={<Quote />} />
      <Route path="/estimation/print/:id?" element={<EPrint />} />
      <Route path="/contact/edit/:id/order/convert-order/:quatationId?" element={<Orders />} />
      <Route path="/contact/edit/:id/order/estimation-convert-order/:estimationId?" element={<Orders />} />

       {/* Vendor Routes */}
      <Route path="/vendor/list" element={<VendorList />} />
      <Route path="/vendor/create" element={<CreateVendor />} />
      <Route path="/vendor/edit/:id" element={<CreateVendor />} />
     
     <Route path="/purchase/list" element={<PurchaseOrderList />} />
    <Route path="/purchase/add" element={<CreatePurchaseOrder />} />
    <Route path="/purchase/edit/:id" element={<CreatePurchaseOrder />} />

    <Route path="/vendorbill/list" element={<VendorBillList />} />
    <Route path="/vendorbill/add" element={<CreateVendorBill />} />
    <Route path="/vendorbill/edit/:id" element={<CreateVendorBill />} />


  <Route path="/vendorpayment/list" element={<VendorPaymentList />} />
  <Route path="/vendorpayment/add" element={<CreateVendorPayment />} />
  <Route path="/vendorpayment/edit/:id" element={<CreateVendorPayment />} />

  <Route path="/expense/list" element={<ExpenseList />} />
  <Route path="/expense/add" element={<CreateExpense />} />
  <Route path="/expense/edit/:id" element={<CreateExpense />} />
  


      
      <Route path="/role/list" element={<RoleList />} />
      <Route path="/role/create" element={<CreateRole />} />
      <Route path="/role/edit/:id" element={<CreateRole />} />

      <Route path="/contact/edit/:id/view-surveyor/:sid" element={<ViewSurveyorTaskDetails />} />
      <Route path="/overview" element={<DashboardOverview />} />
      <Route path="/product/list" element={<ProductList />} />
      <Route path="/product/add" element={<Product />} />
      <Route path="/product/edit/:id" element={<Product />} />

      <Route path="/branch/list" element={<BranchList />} />
      <Route path="/branch/create" element={<Branch />} />
      <Route path="/branch/edit/:id" element={<Branch />} />
      <Route path="/printd" element={<PrintDocBuilder/>}/>

      <Route path="/contact/edit/:id/invoice/:invId?" element={<Invoice />} />
       <Route path="/contact/edit/:id/invoice/convert-invoice/:orderId?" element={<Invoice />} />
      
    </Routes>
  );
};

export default PrivateRoute;
